module.exports = __webpack_public_path__ + "1bf37c842e23fac7e8792bbf065232b8.svg";